import { gql } from '@apollo/client';
import { apolloClient } from '../apollo/client';

export interface DescontoCategoria {
  id?: string;
  torneioId: string;
  tipo: 'PERCENTUAL' | 'FIXO';
  valor: number;
  ordem: number;
  descricao?: string | null;
}

export interface DescontosCategoriaPorTorneioData {
  descontosCategoriaPorTorneio: DescontoCategoria[];
}

export interface DescontosCategoriaPorTorneioVars {
  torneioId: string;
}

export const DESCONTO_CATEGORIAS_POR_TORNEIO = gql`
  query DescontosCategoriaPorTorneio($torneioId: ID!) {
    descontosCategoriaPorTorneio(torneioId: $torneioId) {
      id
      tipo
      valor
      ordem
    }
  }
`;

export interface DescontoCategoriaInput {
  torneioId: string;
  tipo: 'PERCENTUAL' | 'FIXO';
  valor: number;
  ordem: number;
}

export const CRIAR_DESCONTO_CATEGORIA = gql`
  mutation AdicionarDescontoCategoria($input: DescontoCategoriaInput!) {
    adicionarDescontoCategoria(input: $input) {
      id
      tipo
      valor
      ordem
    }
  }
`;

export interface AtualizarDescontoCategoriaVars {
  id: string;
  input: {
    torneioId: string;
    tipo: 'PERCENTUAL' | 'FIXO';
    valor: number;
    ordem: number;
  };
}

export const ATUALIZAR_DESCONTO_CATEGORIA = gql`
  mutation AtualizarDescontoCategoria($id: ID!, $input: DescontoCategoriaInput!) {
    atualizarDescontoCategoria(id: $id, input: $input) {
      id
      tipo
      valor
      ordem
    }
  }
`;

export const REMOVER_DESCONTO_CATEGORIA = gql`
  mutation RemoverDescontoCategoria($id: ID!) {
    removerDescontoCategoria(id: $id)
  }
`;

export const descontosCategoriaPorTorneio = async (
  torneioId: string,
): Promise<DescontoCategoria[]> => {
  const { data } = await apolloClient.query<
    DescontosCategoriaPorTorneioData,
    DescontosCategoriaPorTorneioVars
  >({
    query: DESCONTO_CATEGORIAS_POR_TORNEIO,
    variables: { torneioId },
    fetchPolicy: 'no-cache',
  });
  return data.descontosCategoriaPorTorneio;
};

export const adicionarDescontoCategoria = async (
  input: DescontoCategoriaInput,
): Promise<DescontoCategoria | null> => {
  const { data } = await apolloClient.mutate<
    { adicionarDescontoCategoria: DescontoCategoria },
    { input: DescontoCategoriaInput }
  >({
    mutation: CRIAR_DESCONTO_CATEGORIA,
    variables: { input },
  });
  return data?.adicionarDescontoCategoria ?? null;
};

export const atualizarDescontoCategoria = async (
  vars: AtualizarDescontoCategoriaVars,
): Promise<DescontoCategoria | null> => {
  const { data } = await apolloClient.mutate<
    { atualizarDescontoCategoria: DescontoCategoria },
    AtualizarDescontoCategoriaVars
  >({
    mutation: ATUALIZAR_DESCONTO_CATEGORIA,
    variables: vars,
  });
  return data?.atualizarDescontoCategoria ?? null;
};

export const removerDescontoCategoria = async (
  id: string,
): Promise<boolean> => {
  const { data } = await apolloClient.mutate<
    { removerDescontoCategoria: boolean },
    { id: string }
  >({
    mutation: REMOVER_DESCONTO_CATEGORIA,
    variables: { id },
  });
  return data?.removerDescontoCategoria ?? false;
};

